import {
  Box,
  Building2,
  Circle,
  CreditCard,
  List,
  type LucideIcon,
  School,
  Settings,
  Smartphone,
  Sprout,
  Stethoscope,
  User,
  Users,
} from "lucide-react";
import { Panel } from "rsuite";

const RADIO_ICON_MAP: Record<string, LucideIcon> = {
  user: User,
  users: Users,
  list: List,
  "kit-medical": Stethoscope,
  seedling: Sprout,
  school: School,
  building: Building2,
  "credit-card": CreditCard,
  mobile: Smartphone,
  box: Box,
  cog: Settings,
};

interface IRadioBoxProps {
  icon: string;
  title: string;
  className?: string;
  value?: number | string;
  currentValue?: number | string;
  onClick: (value: number | string) => void;
}
const RadioBox = (props: IRadioBoxProps) => {
  const { icon, title, className, value, currentValue, onClick } = props;

  const selected = value === currentValue;
  const IconComp = RADIO_ICON_MAP[icon] ?? Circle;

  return (
    <Panel className={className} onClick={() => onClick(value ?? "")}>
      <div
        className={`flex w-full cursor-pointer flex-col items-center justify-center gap-1 rounded-lg border-gray-500 p-2 ${
          selected ? "border-2 border-blue-500" : "border"
        } `}
        style={{ height: 120 }}
      >
        <IconComp className="h-5 w-5 text-gray-500" />
        <span className="text-center text-gray-500">{title}</span>
      </div>
    </Panel>
  );
};

export default RadioBox;
